var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9086 0C15.0916 0 19.3074 4.21587 19.3074 9.39884C19.3074 11.8441 18.369 14.0744 16.8334 15.7482L19.8551 18.7636C20.1379 19.0464 20.1388 19.5039 19.856 19.7867C19.7151 19.9295 19.5289 20 19.3435 20C19.1592 20 18.9739 19.9295 18.832 19.7886L15.7738 16.739C14.1651 18.0273 12.1253 18.7986 9.9086 18.7986C4.72563 18.7986 0.508789 14.5818 0.508789 9.39884C0.508789 4.21587 4.72563 0 9.9086 0ZM9.9086 1.44776C5.52382 1.44776 1.95655 5.01407 1.95655 9.39884C1.95655 13.7836 5.52382 17.3509 9.9086 17.3509C14.2924 17.3509 17.8597 13.7836 17.8597 9.39884C17.8597 5.01407 14.2924 1.44776 9.9086 1.44776Z",
    fill: "#2B2A2A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.18e1db5aed18d55cc1a605f35d45b931.svg";
export { ForwardRef as ReactComponent };